import { VisibilityState } from './constants';
import { guid } from './utils/graph';
import { NodeModel } from './types';

export class Global {
  /** Clipboard */
  clipboard: {
    point: {
      x: number;
      y: number;
    };
    models: NodeModel[];
  } = {
    point: {
      x: 0,
      y: 0,
    },
    models: [],
  };

  /** Component data */
  component: {
    itemPanel: {
      model: Partial<NodeModel> | null;
      delegateShapeClassName: string;
    };
  } = {
    itemPanel: {
      model: null,
      delegateShapeClassName: `delegateShape_${guid()}`,
    },
  };

  /** Plug-in data */
  plugin: {
    contextMenu: {
      state: VisibilityState;
    };
    inlineEditInput: {
      state: VisibilityState;
    };
  } = {
    contextMenu: {
      state: VisibilityState.Hide,
    },
    inlineEditInput: {
      state: VisibilityState.Hide,
    },
  };
}

export default Global;
